define("settings/components/cancel-plan/slide/generic-result", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="tCA--title">{{@result.title}}</p>
  <p class="u--m__b__lg">{{html-safe @result.subCopy}}</p>
  */
  {
    "id": "tdKrgmu0",
    "block": "[[[10,2],[14,0,\"tCA--title\"],[12],[1,[30,1,[\"title\"]]],[13],[1,\"\\n\"],[10,2],[14,0,\"u--m__b__lg\"],[12],[1,[28,[35,0],[[30,1,[\"subCopy\"]]],null]],[13]],[\"@result\"],false,[\"html-safe\"]]",
    "moduleName": "settings/components/cancel-plan/slide/generic-result.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});